import { AccordionDetails } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import React, { ChangeEvent, FC, ReactNode, useState } from 'react';
import GcpTypography from '../gcp-typography';

const useStyles = makeStyles(
  () => ({
    root: {
      border: '1px solid rgba(196, 196, 196, 0.5)',
      boxSizing: 'border-box',
      '&.MuiPaper-elevation1': {
        boxShadow: 'none',
      },
      '&.MuiAccordion-rounded:last-child': {
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px',
      },
      '&.MuiAccordion-rounded:first-child': {
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      },
    },
    summary: {
      borderBottom: '1px solid rgba(196, 196, 196, 0.5)',
      borderBottomLeftRadius: '20px',
      borderBottomRightRadius: '20px',
      '& > .MuiAccordionSummary-expandIcon': {
        order: -1,
      },
    },
  }),
  { name: 'GcpAccordion' }
);

interface GcpAccordionProps {
  title: string;
  details: ReactNode;
}

const GcpAccordion: FC<GcpAccordionProps> = (props) => {
  const classes = useStyles();
  const { title, details } = props;
  const [expanded, setExpanded] = useState<boolean>(false);

  const handleChange = (
    event: ChangeEvent<Record<string, unknown>>,
    isExpanded: boolean
  ): void => {
    setExpanded(isExpanded);
  };

  return (
    <Accordion classes={{ root: classes.root }} onChange={handleChange}>
      <AccordionSummary
        aria-controls="panel1a-content"
        classes={{ root: classes.summary }}
        expandIcon={
          expanded ? <ExpandLessOutlinedIcon /> : <ChevronRightOutlinedIcon />
        }
        id="panel1a-header"
      >
        <GcpTypography variant="body2">{title}</GcpTypography>
      </AccordionSummary>
      <AccordionDetails>{details}</AccordionDetails>
    </Accordion>
  );
};

export default GcpAccordion;
